mutation (
  $input: VoucherOrderInput!
) {
  sendVoucherOrder(
    input: $input
  )
}
